module.exports = __webpack_public_path__ + "static/media/3.f1758560.gif";